import React from "react"
import { connect } from "react-redux"
import trans from "trans"

import {
    Button,
    css,
    Grid,
    Div,
    Theme,
    Icon,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import { URL } from "../config/api-config";

import { AITemplatType, RENDERED_TYPE_AUTOWMREMOVE, RENDERED_TYPE_BGREMOVE, RENDERED_TYPE_INPAINTING, RENDERED_TYPE_OUTPAINTING, RENDERED_TYPE_UPSCALE } from "products/types";
import { createNewTemplateForm } from "shape-edit/forms/helpers";
import { IconOutpainting, IconSimilarity } from "app/icons";
import { capitalize } from "lodash";

export interface Props {
    close: Function
}

class NewTemplateModalWrapper extends React.PureComponent<Props> {
    constructor(props) {
        super(props)
    }

    createNewAndCloseModal = (type: AITemplatType) => {
        createNewTemplateForm(type)
        this.props.close()
    }

    render() {
        return (
            <Div minWidth={"600px"} margin={'20px'}>
                <ContentGrid id={'new-template-modal-grid'}>
                    <Button simple={true} onClick={() => this.createNewAndCloseModal(null)} size="big" style={{ display: "grid", alignItems: "center", gridTemplateColumns: "auto 1fr", }}>
                        <div className='icon-circle'>
                            <Icon type="image-radix" size={30} color="blue" />
                        </div>
                        <div className='text-div'>{trans("steps_create_blank")}</div>
                    </Button>
                    <Button simple={true} onClick={() => this.createNewAndCloseModal(null)} size="big" style={{ display: "grid", alignItems: "center", gridTemplateColumns: "auto 1fr" }}>
                        <div className="icon-circle">
                            <Icon type="dimensions-radix" size={35} color="blue" />
                        </div>
                        <div className='text-div'>{trans("steps_create_resize")}</div>
                    </Button>
                    <Button simple={true} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_UPSCALE)} size="big" style={{ display: "grid", alignItems: "center", gridTemplateColumns: "auto 1fr" }}>
                        <div className="icon-circle">
                            <Icon type="padding-radix" size={30} color="blue" />
                        </div>
                        <div className='text-div'>{trans("steps_create_upscale")}</div>
                    </Button>
                    <Button simple={true} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_BGREMOVE)} size="big" style={{ display: "grid", alignItems: "center", gridTemplateColumns: "auto 1fr" }}>
                        <div className="icon-circle">
                            <Icon type="hobby-knife-radix" size={30} color="blue" />
                        </div>
                        <div className='text-div'>{trans("steps_create_bg_removal")}</div>
                    </Button>
                    <Button simple={true} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_AUTOWMREMOVE)} size="big" style={{ display: "grid", alignItems: "center", gridTemplateColumns: "auto 1fr" }}>
                        <div className="icon-circle">
                            <Icon type="eraser-radix" size={30} color="blue" />
                        </div>
                        <div className='text-div'>{trans("steps_create_watermarks")}</div>
                    </Button>
                    <Button simple={true} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_OUTPAINTING)} size="big" style={{ display: "grid", alignItems: "center", gridTemplateColumns: "auto 1fr" }}>
                        <div className="icon-circle">
                            <IconOutpainting size={30} color={Theme.blue} />
                        </div>
                        <div className='text-div'>{capitalize(trans("outpainting"))}</div>
                    </Button>
                    <Button simple={true} onClick={() => this.createNewAndCloseModal(null)} size="big" style={{ display: "grid", alignItems: "center", gridTemplateColumns: "auto 1fr" }}>
                        <div className="icon-circle">
                            <IconSimilarity size={30} color={Theme.blue} />
                        </div>
                        <div className='text-div'>{trans("visual_similarity")}</div>
                    </Button>
                </ContentGrid>

                {/* <ContentGrid>
                    <Button key={'regular_type'} secondary={true} onClick={() => this.props.close()} icon={<>
                        <img key={'1'} src={`${URL.publicPath}/img/template-regular.svg`} className={'icon-image'} alt={trans("graphical_template")} />
                        <div key={'2'} className={'template-name'}>{trans("graphical_template")}</div>
                    </>} />
                    <Button key={'upscale_type'} secondary={true} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_UPSCALE)} icon={<>
                        <img key={'3'} src={`${URL.publicPath}/img/template-upscale.svg`} className={'icon-image'} alt={trans("new_upscale_template")} />
                        <div key={'4'} className={'template-name'}>{trans('new_upscale_template')}</div>
                    </>} />
                    <Button key={'bgremove_type'} secondary={true} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_BGREMOVE)} icon={<>
                        <img key={'5'} src={`${URL.publicPath}/img/template-bgremove.svg`} className={'icon-image'} alt={trans("new_bgremove_template")} />
                        <div key={'6'} className={'template-name'}>{trans('new_bgremove_template')}</div>
                    </>} />
                    <Button key={'wmremove_type'} secondary={true} style={{ position: 'relative' }} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_AUTOWMREMOVE,)} icon={<>
                        <img key={'7'} src={`${URL.publicPath}/img/template-wmremove.svg`} className={'icon-image'} alt={trans("new_wmremove_template")} />
                        <div key={'8'} className={'template-name'}>{trans('new_wmremove_template')}</div>
                        <img key={'9'} src={`${URL.laravelBase}img/icons/beta.svg`} width={100} title={'beta version'} style={{
                            transform: 'rotate(-45deg)',
                            position: 'absolute',
                            right: '-35px',
                            bottom: '0px',
                        }} />
                    </>} />
                    <Button key={'outpainting_type'} secondary={true} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_OUTPAINTING)} icon={<>
                        <img key={'10'} src={`${URL.publicPath}/img/template-outpainting.svg`} className={'icon-image'} alt={trans("template_type_4")} />
                        <div key={'11'} className={'template-name'}>{trans('template_type_4')}</div>
                    </>} />
                    <Button key={'inpainting_type'} secondary={true} onClick={() => this.createNewAndCloseModal(RENDERED_TYPE_INPAINTING)} icon={<>
                        <img key={'12'} src={`${URL.publicPath}/img/template-inpainting.svg`} className={'icon-image'} alt={trans("template_type_6")} />
                        <div key={'13'} className={'template-name'}>{trans('template_type_6')}</div>
                    </>} />
                </ContentGrid> */}
            </Div>
        )
    }
}

const ContentGrid = css(Grid)({
    gridTemplateColumns: '1fr 1fr',
    gridGap: '10px',
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
    },
    ' .template-name': {
        marginBottom: '5px',
        padding: '5px',
    },
    ' img.icon-image': {
        maxWidth: '60px',
        maxHeight: '60px',
    },
    ' .muk-button': {
        padding: '10px',
        borderRadius: '10px',
        background: '#ffffff',
    },
    ' .icon-circle': {
        padding: '10px',
        boxShadow: '2px 2px 5px rgba(0,0,0,.1)',
        border: `1px solid ${Theme.blue}`,
        margin: '1px',
        borderRadius: '100%',
    },
    ' .text-div': {
        padding: '10px',
        textAlign: 'left',
    }
})

export default NewTemplateModalWrapper